import { useState, useEffect } from 'react';
import { ServiceNoReplyEmail } from '../../services/service-noreply-email';
import AppLayout from '../../components/layout/app-layout/app-layout';
import BtButton from '../bt-button/bt-button';
import './page-noreply-email.scss';

const PageNoReplyEmail = () => {
  const [status, setStatus] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error', text: string } | null>(null);

  const fetchStatus = async () => {
    try {
      const result = await ServiceNoReplyEmail.getStatus();
      setStatus(result);
    } catch (error: any) {
      console.error('Error fetching status:', error);
    }
  };

  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 10000);
    return () => clearInterval(interval);
  }, []);

  const handleProcessNow = async () => {
    setLoading(true);
    setMessage(null);
    try {
      const result = await ServiceNoReplyEmail.processUnreadEmails();
      if (result.success) {
        setMessage({ type: 'success', text: result.message });
      } else {
        setMessage({ type: 'error', text: result.message });
      }
      await fetchStatus();
    } catch (error: any) {
      setMessage({ type: 'error', text: error.message || 'Failed to process emails' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppLayout title="NoReply Email Service">
      <div style={{ margin: '32px' }}>
        <p style={{ color: 'var(--gray-600)', marginBottom: '24px' }}>
          Manage the email processing service for conversation replies
        </p>

        {message && (
          <div className={`message-banner message-${message.type}`}>
            {message.text}
          </div>
        )}

        <div className="status-section">
          <h2>Current Status</h2>
          {status ? (
            <div className="status-grid">
              <div className="status-item">
                <span className="status-label">Running on this server:</span>
                <span className={`status-value ${status.isRunningOnThisServer ? 'active' : 'inactive'}`}>
                  {status.isRunningOnThisServer ? '✓ Yes' : '✗ No'}
                </span>
              </div>

              {status.currentLock && (
                <>
                  <div className="status-item">
                    <span className="status-label">Lock ID:</span>
                    <span className="status-value status-code">{status.currentLock.lockId}</span>
                  </div>
                  <div className="status-item">
                    <span className="status-label">Lock age:</span>
                    <span className="status-value">{Math.floor(status.currentLock.age / 1000)}s</span>
                  </div>
                </>
              )}

              <div className="status-item">
                <span className="status-label">Last sync:</span>
                <span className="status-value">
                  {status.lastSyncTime 
                    ? new Date(status.lastSyncTime).toLocaleString() 
                    : 'Never'}
                </span>
              </div>

              <div className="status-item">
                <span className="status-label">Cached emails:</span>
                <span className="status-value">{status.emailCount}</span>
              </div>
            </div>
          ) : (
            <p>Loading status...</p>
          )}
        </div>

        <div className="actions-section">
          <h2>Actions</h2>
          <div className="action-buttons">
            <BtButton 
              onClick={handleProcessNow}
              disabled={loading}
            >
              Process Emails Now
            </BtButton>
          </div>

          <div className="help-section">
            <p><strong>Process Emails Now:</strong> Manually triggers email processing once. Auto-refresh runs on all servers at startup; one server processes per cycle.</p>
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default PageNoReplyEmail;
